import { render, staticRenderFns } from "./FitData.vue?vue&type=template&id=11cd5e47&scoped=true&"
import script from "./FitData.vue?vue&type=script&lang=js&"
export * from "./FitData.vue?vue&type=script&lang=js&"
import style0 from "./FitData.vue?vue&type=style&index=0&id=11cd5e47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd5e47",
  null
  
)

export default component.exports